var map = {
	"./background-color.svg": "8150",
	"./option-background-color.svg": "7c76",
	"./option-text-color.svg": "b0c0a",
	"./primary-button-background-color.svg": "ebce",
	"./primary-button-text-color.svg": "47fc",
	"./secondary-button-background-color.svg": "d1cc",
	"./secondary-button-text-color.svg": "209a",
	"./title-color.svg": "1299"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b738";